// Interface definitions
interface TertiaryItem {
  id: string;
  productName: string;
  imageBlk: string;
  imageWht: string;
  isNew: boolean;
  categoryId?: string;
}

interface BrandItem {
  id: string;
  name: string;
  logoSrc: string;
  href: string;
}

export interface AppleNavData {
  showTertiaryNav: boolean;
  tertiaryItems: TertiaryItem[];
  brandItems: BrandItem[];
  searchPlaceholder: string;
}

export class TertiaryAppleNavigationService {
  private _navigationData: AppleNavData = {
    showTertiaryNav: true,
    tertiaryItems: [],
    brandItems: [
      {
        id: 'apple',
        name: 'Apple',
        logoSrc: '/placeholder.svg?height=40&width=40',
        href: '/apple',
      },
      {
        id: 'beats',
        name: 'Beats',
        logoSrc: '/placeholder.svg?height=40&width=40',
        href: '/beats',
      },
    ],
    searchPlaceholder: 'Search Apple products',
  };

  public getNavigationData(categoryId: string): AppleNavData {
    switch (categoryId) {
      case '60002': // Mac
        this._navigationData.tertiaryItems = [
          {
            id: 'mac-book-neo',
            productName: 'MacBook Neo',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/macbookneo_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/macbookneo_wht.svg',
            isNew: false,
            categoryId: '62028',
          },
          {
            id: 'mac-book-air',
            productName: 'MacBook Air',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/macbookair_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/macbookair_wht.svg',
            isNew: false,
            categoryId: '62021',
          },
          {
            id: 'mac-book-pro',
            productName: 'MacBook Pro',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/macbookpro_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/macbookpro_wht.svg',
            isNew: false,
            categoryId: '62022',
          },
          {
            id: 'mac-mini',
            productName: 'Mac mini',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/macmini_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/macmini_wht.svg',
            isNew: true,
            categoryId: '62023',
          },
          {
            id: 'mac-studio',
            productName: 'Mac Studio',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/macstudio_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/macstudio_wht.svg',
            isNew: true,
            categoryId: '62024',
          },
          {
            id: 'imac-24',
            productName: 'iMac 24"',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/imac24_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/imac24_wht.svg',
            isNew: false,
            categoryId: '62025',
          },
          {
            id: 'displays',
            productName: 'Studio Displays',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/displays_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/displays_wht.svg',
            isNew: false,
            categoryId: '62026',
          },
          {
            id: 'mac-accessories',
            productName: 'Mac Accessories',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/accessories_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/accessories_wht.svg',
            isNew: false,
            categoryId: '62027',
          },
        ];
        this._navigationData.searchPlaceholder = 'Search Mac products';
        break;

      case '60003': // iPad
        this._navigationData.tertiaryItems = [
          {
            id: 'ipad-pro',
            productName: 'iPad Pro',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/ipad/ipad_pro_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/ipad/ipad_pro_wht.svg',
            isNew: false,
            categoryId: '61006',
          },
          {
            id: 'ipad-air',
            productName: 'iPad Air',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/ipad/ipad_air_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/ipad/ipad_air_wht.svg',
            isNew: true,
            categoryId: '61003',
          },
          {
            id: 'ipad',
            productName: 'iPad',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/ipad/ipad_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/ipad/ipad_wht.svg',
            isNew: false,
            categoryId: '61004',
          },
          {
            id: 'ipad-mini',
            productName: 'iPad Mini',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/ipad/ipad_mini_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/ipad/ipad_mini_wht.svg',
            isNew: false,
            categoryId: '61005',
          },
          {
            id: 'apple-pencil',
            productName: 'Apple Pencil',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/ipad/apple_pencil_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/ipad/apple_pencil_wht.svg',
            isNew: false,
            categoryId: '61002',
          },
          {
            id: 'ipad-keyboard',
            productName: 'iPad Keyboard',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/ipad/keyboard_ipad_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/ipad/keyboard_ipad_wht.svg',
            isNew: false,
            categoryId: '61007',
          },
          {
            id: 'ipad-accessories',
            productName: 'iPad Accessories',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/ipad/accessories_ipad_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/ipad/accessories_ipad_wht.svg',
            isNew: false,
            categoryId: '61001',
          },
        ];
        this._navigationData.searchPlaceholder = 'Search iPad products';
        break;

      case '60004': // iPhone
        this._navigationData.tertiaryItems = [
          // {
          //   id: 'iphone-17-pro',
          //   productName: 'iPhone 17 Pro',
          //   imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/iphone/iphone_16_pro_blk.svg',
          //   imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/iphone/iphone_16_pro_wht.svg',
          //   isNew: false,
          //   categoryId: '62150',
          // },
          {
            id: 'iphone-18',
            productName: 'iPhone 18 Pro',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/iphone/iphone_18_pro_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/iphone/iphone_18_pro_wht.svg',
            isNew: true,
            categoryId: '62171',
          },
          {
            id: 'iphone-air',
            productName: 'iPhone Air',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/iphone/iphone_16e_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/iphone/iphone_16e_wht.svg',
            isNew: false,
            categoryId: '62013',
          },
          {
            id: 'iphone-17',
            productName: 'iPhone 17',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/iphone/iphone_16e_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/iphone/iphone_16e_wht.svg',
            isNew: false,
            categoryId: '62140',
          },
          {
            id: 'iphone-17e',
            productName: 'iPhone 17e',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/iphone/iphone_17e_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/iphone/iphone_17e_wht.svg',
            isNew: false,
            categoryId: '62016',
          },
          {
            id: 'iphone-16',
            productName: 'iPhone 16',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/iphone/iphone_16blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/iphone/iphone_16wht.svg',
            isNew: false,
            categoryId: '62006',
          },
          {
            id: 'iphone-accessories',
            productName: 'iPhone Accessories',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/iphone/accessories_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/iphone/accessories_wht.svg',
            isNew: false,
            categoryId: '62001',
          },
        ];
        this._navigationData.searchPlaceholder = 'Search iPhone products';
        break;

      case '60005': // Watch
        this._navigationData.tertiaryItems = [
          {
            id: 'apple-watch-series-12',
            productName: 'Apple Watch Series 12',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/watch/watch_s12_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/watch/watch_s12_wht.svg',
            isNew: true,
            categoryId: '63010',
          },
          {
            id: 'apple-watch-ultra-4',
            productName: 'Apple Watch Ultra 4',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/watch/watch_ultra_4_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/watch/watch_ultra_4_wht.svg',
            isNew: true,
            categoryId: '63011',
          },
          {
            id: 'apple-watch-se-3',
            productName: 'Apple Watch SE',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/watch/watch_se3_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/watch/watch_se3_wht.svg',
            isNew: false,
            categoryId: '63009',
          },
          {
            id: 'watch-bands',
            productName: 'Watch Bands',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/watch/watch_bands_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/watch/watch_bands_wht.svg',
            isNew: true,
            categoryId: '63003',
          },
          {
            id: 'watch-accessories',
            productName: 'Watch Accessories',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/watch/watch_accessories_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/watch/watch_accessories_wht.svg',
            isNew: false,
            categoryId: '63001',
          },
        ];
        this._navigationData.searchPlaceholder = 'Search Apple Watch products';
        break;

      case '60007': // AirPods
        this._navigationData.tertiaryItems = [
          {
            id: 'airpods-pro-3',
            productName: 'AirPods Pro 3',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/airpods/airpods_pro_3_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/airpods/airpods_pro_3_wht.svg',
            isNew: false,
            categoryId: '62034',
          },
          {
            id: 'airpods-5',
            productName: 'AirPods 5',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/airpods/airpods_5_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/airpods/airpods_5_wht.svg',
            isNew: true,
            categoryId: '62035',
          },
          {
            id: 'airpods-max-2',
            productName: 'AirPods Max 2',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/airpods/airpods_max_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/airpods/airpods_max_wht.svg',
            isNew: true,
            categoryId: '62032',
          },
        ];
        this._navigationData.searchPlaceholder = 'Search AirPods products';
        break;

      case '60008': // TV & Home
        this._navigationData.tertiaryItems = [
          {
            id: 'apple-tv-4k',
            productName: 'Apple TV 4K',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/tvhome/apple_tv4k_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/tvhome/apple_tv4k_wht.svg',
            isNew: false,
            categoryId: '62041',
          },
          {
            id: 'homepod',
            productName: 'HomePod',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/tvhome/homepod_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/tvhome/homepod_wht.svg',
            isNew: false,
            categoryId: '62043',
          },
          {
            id: 'homepod-mini',
            productName: 'HomePod Mini',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/tvhome/homepodmini_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/tvhome/homepodmini_wht.svg',
            isNew: false,
            categoryId: '62044',
          },
        ];
        this._navigationData.searchPlaceholder = 'Search TV & Home products';
        break;

      default:
        // Default case - show all main categories
        this._navigationData.tertiaryItems = [
          {
            id: 'mac',
            productName: 'Mac',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/imac24_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/imac24_wht.svg',
            isNew: false,
            categoryId: '60002',
          },
          {
            id: 'ipad',
            productName: 'iPad',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/ipad/ipad_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/ipad/ipad_wht.svg',
            isNew: false,
            categoryId: '60003',
          },
          {
            id: 'iphone',
            productName: 'iPhone',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/iphone/iphone_16_pro_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/iphone/iphone_16_pro_wht.svg',
            isNew: false,
            categoryId: '60004',
          },
          {
            id: 'watch',
            productName: 'Watch',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/watch/watch_s10_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/watch/watch_s10_wht.svg',
            isNew: false,
            categoryId: '60005',
          },
          {
            id: 'airpods',
            productName: 'AirPods',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/airpods/airpods_pro_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/airpods/airpods_pro_wht.svg',
            isNew: false,
            categoryId: '60007',
          },
          {
            id: 'tv-home',
            productName: 'TV & Home',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/tvhome/apple_tv4k_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/tvhome/apple_tv4k_wht.svg',
            isNew: false,
            categoryId: '62041',
          },
          {
            id: 'accessories',
            productName: 'Accessories',
            imageBlk: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/accessories_blk.svg',
            imageWht: 'https://maxsite.b-cdn.net/Chase/Apple/Icons/mac/accessories_wht.svg',
            isNew: false,
            categoryId: '60010',
          },
        ];
        this._navigationData.searchPlaceholder = 'Search Apple products';
        break;
    }

    return this._navigationData;
  }
}
